import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'feed',
    layout: '1',
  },
  itemDesign: {},
  containerDesign: {},
};

export const videoSlice = createSlice({
  name: 'video',
  initialState,
  reducers: {
    videoStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = {
        // textColor: itemDesign.textColor ?? '#000000',
        // opacity: itemDesign.opacity ?? 0,
        // size: itemDesign.size ?? 50,
        shape: itemDesign.shape ?? 'round',
        border: itemDesign.border ?? 'none',
        borderColor: itemDesign.borderColor ?? '#000000',
        shadow: itemDesign.shadow ?? 'none',
        shadowColor: itemDesign.shadowColor ?? '#000000',
      };
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'feed',
        layout: blockDesign.layout ?? '1',
      };
    },
    videoClear: () => initialState,

    videoUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    videoUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    videoUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    videoUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { videoStore, videoClear, videoUpdateIsLoading, videoUpdateIsActive, videoUpdateBlockContent, videoUpdateBlockDesign } = videoSlice.actions;

export const selectVideoIsLoading = (state) => state.video.isLoading;

export const selectVideoId = (state) => state.video.id;
export const selectVideoUID = (state) => state.video.uid;
export const selectVideoSID = (state) => state.video.sid;

export const selectVideoBlockContent = (state) => state.video.blockContent;
export const selectVideoBlockDesign = (state) => state.video.blockDesign;
export const selectVideoSortItems = createSelector([selectVideoBlockContent], ({ items }) => {
  return sortItems(items);
});
export const selectVideoItemDesign = (state) => state.video.itemDesign;
export const selectVideoContainerDesign = (state) => state.video.containerDesign;

export default videoSlice.reducer;
